export default "__VITE_ASSET__D6cy92Xq__"